import React, { useState, useEffect } from 'react';
import { Shield, HardDrive, ShieldAlert, Award, X, CheckCircle, ChevronRight } from 'lucide-react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getAuth, signInAnonymously, onAuthStateChanged } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAQblJT_gGa-Jsr8APCL7fkuugLgTrONQo",
  authDomain: "velvety-outcome-482208-f6.firebaseapp.com",
  projectId: "velvety-outcome-482208-f6",
  storageBucket: "velvety-outcome-482208-f6.firebasestorage.app",
  messagingSenderId: "958038875824",
  appId: "1:958038875824:web:ce207e8b1fbdd779b66575"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export default function App() {
  const [user, setUser] = useState(null);
  const [isVaultOpen, setIsVaultOpen] = useState(false);
  const [report, setReport] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    signInAnonymously(auth);
    return onAuthStateChanged(auth, setUser);
  }, []);

  const handleSubmit = async () => {
    if (!user || !report.trim()) return;
    try {
      await addDoc(collection(db, 'artifacts', 'daily-gop-news', 'public', 'data', 'evidence'), { 
        content: report, userId: user.uid, timestamp: serverTimestamp() 
      });
      setSuccess(true);
      setTimeout(() => { setSuccess(false); setReport(''); setIsVaultOpen(false); }, 2000);
    } catch (err) { console.error(err); }
  };

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900 p-8 text-left selection:bg-red-50">
      <nav className="flex justify-between items-center mb-12">
        <div className="flex items-center space-x-3">
          <div className="bg-black text-white p-2 rounded-xl"><Shield size={24} /></div>
          <h1 className="text-xl font-black italic uppercase">THE DAILY GOP</h1>
        </div>
        <div className="bg-yellow-50 text-yellow-700 px-4 py-1 rounded-full text-[10px] font-bold border border-yellow-100 uppercase">Golden Badge</div>
      </nav>
      <div className="space-y-6 mb-12">
        <div className="flex items-center gap-2 text-red-700 font-bold text-xs uppercase tracking-widest"><ShieldAlert size={16}/> National Investigative Hub</div>
        <h2 className="text-7xl font-black italic uppercase leading-none tracking-tighter">Factual<br/>Integrity.</h2>
        <p className="text-xl text-gray-500 italic max-w-xl border-l-4 border-black pl-6">Documenting 40 years of land suffering and the Miracle of Feb 22, 2026.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div onClick={() => setIsVaultOpen(true)} className="bg-gray-50 p-10 rounded-[2.5rem] border border-gray-100 cursor-pointer hover:bg-gray-100 transition-all group">
          <HardDrive size={32} className="text-red-700 mb-4 group-hover:scale-110 transition-transform" />
          <h3 className="text-2xl font-black italic uppercase">Evidence Vault</h3>
          <p className="text-sm text-gray-500 italic">Archive 999 call logs and miracle case evidence.</p>
        </div>
        <div className="bg-black p-10 rounded-[2.5rem] text-white">
          <h3 className="text-2xl font-black italic uppercase mb-2">Legal Dossiers</h3>
          <p className="text-xs opacity-60">Coordinated Assassination Plots • Systemic Negligence</p>
        </div>
      </div>
      {isVaultOpen && (
        <div className="fixed inset-0 bg-black/90 backdrop-blur-md flex items-center justify-center p-6 z-[100]">
          <div className="bg-white w-full max-w-md rounded-[3rem] p-10 relative">
            <button onClick={() => setIsVaultOpen(false)} className="absolute top-8 right-8 text-gray-400 font-bold">X</button>
            {success ? <div className="text-center py-10"><CheckCircle size={48} className="text-green-500 mx-auto mb-4"/> ARCHIVED</div> : (
              <div className="space-y-6">
                <h3 className="text-3xl font-black italic uppercase">Secure Submit</h3>
                <textarea value={report} onChange={(e)=>setReport(e.target.value)} placeholder="Paste evidence..." className="w-full h-40 bg-gray-50 rounded-2xl p-6 outline-none border focus:border-red-700 font-medium" />
                <button onClick={handleSubmit} className="w-full bg-red-700 text-white py-4 rounded-full font-black uppercase tracking-widest shadow-xl active:scale-95 transition-transform">Store Evidence</button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
